import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import { db, collection, query, getDocs, orderBy } from "../../firebase";
import AdminLeftMenu from "./AdminLeftMenu";
import { useTranslation } from "react-i18next";
import AdminCheck from "./AdminCheck";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  pl: 2,
  pr: 8,
};

const AdminSentEmails = () => {
  const { t, i18n } = useTranslation();
  const numOfItems = 6;
  const [currentPage, setCurrentPage] = useState(0);
  const [mails, setMails] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [clicked, setClicked] = useState(null);
  const [page, setPage] = React.useState(1);
  const handleChange = (event, value) => {
    setPage(value);
    console.log(value);
  };

  useEffect(() => {
    setMails([]);
    const getMails = async () => {
      const q = query(
        collection(db, "mail"),
        orderBy("delivery.startTime", "desc")
      );

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc2) => {
        setMails((old) =>
          old.concat({
            ...doc2.data(),
            id: doc2.id,
          })
        );
      });
    };
    getMails();
  }, []);

  const openModal = (mail) => {
    setClicked(mail);
    handleOpen();
  };

  console.log(mails);

  return (
    <Grid container>
      <AdminCheck />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            {clicked?.message.subject}
          </Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <div dangerouslySetInnerHTML={{ __html: clicked?.message.html }} />
          </Typography>
        </Box>
      </Modal>
      <AdminLeftMenu />
      <Grid item md={9} sm={12}>
        <Grid container>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            sx={{ backgroundColor: "#faf9f6" }}
          >
            <Box sx={{ py: 6, px: 3 }}>
              {/* Content */}
              <Box sx={{ display: "flex" }} justifyContent={"space-between"}>
                <Box sx={{ fontSize: "16px", fontWeight: 800 }}>
                  {t("Sent Emails")}
                </Box>
              </Box>
              <Box
                sx={{
                  mt: 2,
                  borderRadius: "2px",
                  display: "flex",
                  fontSize: "20px",
                }}
              >
                <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    backgroundColor: "white",
                    p: { md: 4, sm: 1 },
                    textAlign: "center",
                    py: 2,
                    fontSize: "15px",
                  }}
                >
                  {t("Number of Sent Mails")}
                  <Box sx={{ fontSize: "35px", pt: 2 }}>{mails?.length}</Box>
                  {/* <Box sx={{ color: "gray", fontSize: "13px", pt: 3 }}>
                    Just Now
                  </Box> */}
                </Box>
                {/* <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 2,
                  }}
                >
                  Number Of Admins
                  <Box sx={{ fontSize: "19px", pt: 2 }}></Box>
                </Box> */}
                {/* <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 2,
                  }}
                >
                  Number of Admins
                  <Box sx={{ fontSize: "19px", pt: 2 }}>{orders?.length}</Box>
                </Box> */}
                {/* <Box
                  sx={{
                    width: 1 / 4,
                    border: "1px solid lightgray",
                    borderLeft: "none",
                    backgroundColor: "white",
                    textAlign: "center",
                    p: { md: 4, sm: 1 },
                    py: 2,
                  }}
                >
                  Revenue<Box sx={{ fontSize: "19px", pt: 2 }}>$12</Box>
                </Box> */}
              </Box>
              <Grid container>
                <Grid item md={12} sm={12} xs={12} sx={{ mb: 5 }}>
                  <Box
                    sx={{
                      border: "1px solid lightgray",
                      my: 5,
                      mr: { md: 5, sm: 0, xs: 0 },
                      backgroundColor: "white",
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: "1px solid lightgray",
                        py: 2,
                        px: 4,
                        fontWeight: "bold",
                        fontSize: "19px",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "14px",
                      }}
                    >
                      <Box>이메일들</Box>
                      {/* <Box className="pink_link" sx={{ fontSize: "13px" }}>
                        Setting
                      </Box> */}
                    </Box>
                    <Box
                      sx={{
                        py: 2,
                        px: 4,
                        minHeight: "300px",
                      }}
                    >
                      {mails
                        .slice((page - 1) * numOfItems, numOfItems * page)
                        .map((mail, idx) => {
                          return (
                            <Box
                              key={idx}
                              sx={{
                                borderBottom: "1px solid lightbox",
                                py: 2,
                                display: "flex",
                              }}
                            >
                              <Box sx={{ pr: 2 }}>
                                <EmailOutlinedIcon sx={{ color: "#bdbdbd" }} />
                              </Box>
                              <Box>
                                <Box>
                                  {/* {mail?.delivery.endTime
                                    .toDate()
                                    .toDateString() +
                                    " " +
                                    mail.delivery.endTime
                                      .toDate()
                                      .toTimeString()} */}
                                </Box>
                                <span className="gray">{t("sent To")}:</span>{" "}
                                {mail.to}
                                <Box sx={{ mt: "6px" }}>
                                  <span className="gray">
                                    {t("sent Message")}:
                                  </span>{" "}
                                  <span
                                    className="pink_link"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => openModal(mail)}
                                  >
                                    {mail.message.subject}
                                  </span>
                                  <Box sx={{ pt: "5px" }}>
                                    <span className="gray">시간:</span>{" "}
                                    {mail.delivery.startTime
                                      ?.toDate()
                                      .toLocaleDateString("fr-CA", {
                                        year: "numeric",
                                        month: "2-digit",
                                        day: "2-digit",
                                      })}{" "}
                                    {mail.delivery.startTime
                                      ?.toDate()
                                      .toLocaleTimeString("ko-KR")}
                                  </Box>
                                </Box>
                              </Box>
                            </Box>
                          );
                        })}
                    </Box>
                    <Box sx={{ display: "flex", pb: 3, px: 5 }}>
                      <Pagination
                        count={Math.ceil(mails.length / numOfItems)}
                        variant="outlined"
                        color="secondary"
                        sx={{ my: 2 }}
                        onChange={handleChange}
                        page={page}
                      />
                      {/* {Array.apply(null, {
                        length: Math.ceil(mails.length / numOfItems),
                      }).map((e, i) => {
                        if (currentPage === i) {
                          return (
                            <Box
                              key={i}
                              sx={{
                                border: "1px solid lightgray",
                                margin: "2px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                py: 1,
                                color: "#153a5a",
                                backgroundColor: "#f5f5f5",
                              }}
                              onClick={(e) => setCurrentPage(i)}
                            >
                              {i + 1}
                            </Box>
                          );
                        } else {
                          return (
                            <Box
                              key={i}
                              sx={{
                                border: "1px solid lightgray",
                                margin: "2px",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                py: 1,
                                cursor: "pointer",
                              }}
                              onClick={(e) => setCurrentPage(i)}
                            >
                              {i + 1}
                            </Box>
                          );
                        }
                      })} */}
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* End of Content */}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AdminSentEmails;
// users
